jQuery(document).ready(function($) {

    isSmallMobile = {
        any: function() {
            return $(window).width() < 767;
        }
	};

	if ($(".home").length)  {
		if ($(window).width() > 767) {

			setTimeout(function() {
				$("#homepage-advanced-search select").selectpicker({ dropupAuto: false });
				$("body").on('search_filters_rendered', function() {
				$("#homepage-advanced-search select").selectpicker('refresh');
			});
				$("#homepage-advanced-search .filters").fadeIn();
			}, 600);
		}
	}

	// Mobile Footer Menus
	if ($(window).width() <= 768) {
		$('.linkWrapper__widgets .widget').on('click', function(){
			$(this).toggleClass('active').siblings().removeClass('active');
			$(this).find(' > div').slideToggle().parent().siblings().find(' > div').slideUp();
		});
	}

        // START -> HEADER SEARCH TOGGLE
	$(".open-overlay").click(function() {
		$('#fullOverlay').toggleClass("open");
		$('#searchOverlay__overlay').css('display', 'block');
	});

	$("#search-toggle").click(function() {
		$('input#alg-search').focus();
	});
    // END -> HEADER SEARCH TOGGLE

     $(".why-us").click(function(){
	  $(".why-us").toggleClass("open");
      $(".why-drop-down").toggleClass("open");
	});
	
	var models_slider = new Swiper('.modelRow .swiper-container', {
		speed: 300,
		slidesPerGroup: 3,
		slidesPerView: 3,
		lazy: {
			enabled: true,
		},
		navigation: {
			nextEl: '.swiper-button-next.model',
			prevEl: '.swiper-button-prev.model'
		},
		breakpoints: {
			1024: {
				slidesPerGroup: 2,
				slidesPerView: 2
			},
			767: {
				slidesPerGroup: 1,
				slidesPerView: 1
			},
		},
		
	});

	// Lazyload - show images on button click
    $(".modelRow .wrapperRow__navigation .model").click(function(){
        $(".modelRow  .vehicle-box__image img").each(function() {
            $(this).attr("src", $(this).attr("data-original"));
        });
    });
	
	$('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
		var index = $(this).parent().index()
		if (models_slider && models_slider[index]) {
			models_slider[index].update();
			models_slider[index].navigation.update();
		}
		if (typeof LazyLoad === "function") {
			var myLazyLoad = new LazyLoad();
		}
	});

	// start 00364248
	if ($(".home").length)  {
		var lazyLoadImages = [
			{ div:".VideoRow__video",
			style:"background-image: url('/wp-content/themes/DealerInspireDealerTheme/images/video-bg.jpg?ver=2.0')",
			path:'/wp-content/themes/DealerInspireDealerTheme/images/video-bg.jpg',
			loaded:false,
			},
			{ div:".seo__bg",
			style:"background-image: url('/wp-content/themes/DealerInspireDealerTheme/images/seo-bg.jpg')",
			path:'/wp-content/themes/DealerInspireDealerTheme/images/seo-bg.jpg',
			loaded:false,
			},
		];
		lazyLoadBackground(lazyLoadImages);
	}
	// end 00364248

	$('.call-now').insertAfter('.ctabox-row.with-savings');
	$('.finance.visible-xs').insertBefore('#details-page-ctabox');

	// 00374856
	if ($('.countdown-timer').length) {
        $('body').addClass('countdown-timer-active');
        $('.countdown-timer-tab').insertAfter('.countdown-timer__message');
	}
	// end 00374856

	//00518426 start

	//00842656
	$('.di-slide-overlay.hidden-xs').insertBefore("#heros-page-5");
	//00842656 END

	//00636549 revert
	if ( $(".page-vehicle-display-page")[0] ) {
		setTimeout(
			function() 
			{
				$("#bbb-badge").css("position", "absolute");
				$("#bbb-badge").css("z-index", "1001");
			}, 5000);
	}
	//00518426 end

});
